import React from 'react';

export default class Summary extends React.Component{
    constructor( props ){
        super(props);
        this.state = {
            min: 0,
            max: 0,
            list: this.props.content,
            selected: false
        }
        this.updateSummary = this.updateSummary.bind();
    }

    componentWillReceiveProps(next){
        let list = this.props.content.filter( e => e.selected == true );
        let profiles = [];
        //Reset
        this.setState({ selected: false });

        list.map((profile) => {
            profile.profiles.map( data => {
                if(data.selected){
                    profiles.push(data);
                }
            })
        })

        if(profiles.length > 0 ){
            this.updateSummary();
            this.setState({ selected: true })
        }
    }

    updateSummary = () => {

        let category = this.props.content;
        let minBudget = 0;
        let maxBudget = 0;

        category = category.filter( e => e.selected == true);
        category.map(data => {
            data.profiles.map( profile => {
                if( profile.selected ){
                    minBudget += profile.quantity * data.min_range;
                    maxBudget += profile.quantity * data.max_range;
                }
            })
        })

        this.setState({min: minBudget, max: maxBudget}, () => {
            this.props.rangeBudget( minBudget, maxBudget);
        })
    }

    render(){
        let { selected } = this.state;
        let content = null;
        let template = () => {
            return(
                <div>
                    <h3>Summary Budget</h3>
                    <div className="list-cards">
                        <div className="card">
                            <div className="inner">
                                <p>$ {this.state.min}</p>
                                <span>Min Range Budget</span>
                            </div>
                        </div>
                        <div className="card">
                            <div className="inner">
                                <p>$ {this.state.max}</p>
                                <span>Max Range Budget</span>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        if(selected){
            content = template();
        }

        return (
            <section className="summary">
                {content}
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/build-your-team/views/summary.js